/**
 *  Safely casts the provided data to a player time object.
 *  Required as Gamma's type defition for onTime(time: number) is incorrect.
 *
 * @param {unknown} data
 * @returns {{
 *   position: number,
 *   duration: number,
 *   currentTime: number,
 *   seekRange: {
 *     start: number,
 *     end: number
 *   },
 *   metadata: {
 *     currentTime: number
 *   },
 *   absolutePosition: number | null,
 *   type: string,
 *   viewable: number
 * } | null}
 */
export function castToPlayerTimeEventData(data) {
  if (
    typeof data === 'object'
    && data !== null
    && 'position' in data
    && 'currentTime' in data
    && 'duration' in data
    && 'seekRange' in data
    && 'metadata' in data
    && 'absolutePosition' in data
    && 'type' in data
    && 'viewable' in data
  ) {
    /** @type {any} */
    const timeObj = data;
    return timeObj;
  }

  return null;
}
